import React from 'react';
import IntlContext from './IntlContext';

const errorMsg = (id, locale, defaultMessage) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(`[React Intl] Missing message: \"${id}\" for locale: \"${locale}\" (\"${defaultMessage}\", using default message as fallback.)`);
  }
};

const getMessage = (id, { messages, locale }, defaultMessage = '') => {
  if (!messages[id]) {
    errorMsg(id, locale, defaultMessage);
    return defaultMessage;
  }
  return messages[id];
};

const getMessagesList = (ids, intl) => ids.map(id => getMessage(id, intl));

const getTranslations = (id, intl, defaultMessage) => Array.isArray(id) && getMessagesList(id, intl) || getMessage(id, intl, defaultMessage);

const createRenderFn = renderFn => messages => Array.isArray(messages) && renderFn(...messages) || renderFn(messages);

const FormattedMessage = ({ id, children, defaultMessage }) => (
  <IntlContext.Consumer>
    {(intl) => {
      const messages = getTranslations(id, intl, defaultMessage);
      return typeof children === 'function' && createRenderFn(children)(messages) || messages;
    }}
  </IntlContext.Consumer>
);

export default FormattedMessage;



// WEBPACK FOOTER //
// ./src/universal/components/Intl/FormattedMessage.js